import { groupCreationConstants } from "actions/types";
import type { GroupCreationState } from "types/state";

export const groupCreation = (
  state: GroupCreationState = { groupCreation: false },
  action: { type: string }
): GroupCreationState => {
  switch (action.type) {
    case groupCreationConstants.GROUP_CREATION_SHOW:
      return { ...state, groupCreation: true };
    case groupCreationConstants.GROUP_CREATION_HIDE:
      return { ...state, groupCreation: false };
    default:
      return state;
  }
};
